import {Routes} from '@angular/router';

import {OidcAuthRouteGuardService} from '@auth/services/oidc-auth-route-guard';
import {EntityRouteGuard} from '@overview/services/entity-route-guard';
import {DashboardRouteContext} from '@context/old_index';

export const dashboardRoutes: Routes = [

  {
    path: 'main',
    data: {
      routeContext: DashboardRouteContext.create('None')
    },
    canActivate: [OidcAuthRouteGuardService],
    loadChildren: () => import('@mojo-mci/home-dashboard/home-dashboard.module').then(m => m.HomeDashboardModule),
  },
  {
    path: 'manager/:managerId',
    data: {
      routeContext: DashboardRouteContext.create('Manager', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/managers-dashboard/managers-dashboard.module').then(m => m.ManagersDashboardModule),
  },
  {
    path: 'debtor/:debtorId',
    data: {
      routeContext: DashboardRouteContext.create('Debtor', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/debtors-dashboard/debtors-dashboard.module').then(m => m.DebtorsDashboardModule),
  },
  {
    path: 'supplier/:supplierId',
    data: {
      routeContext: DashboardRouteContext.create('Supplier', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/suppliers-dashboard/suppliers-dashboard.module').then(m => m.SuppliersDashboardModule),
  },
  {
    path: 'creditor/:creditorId',
    data: {
      routeContext: DashboardRouteContext.create('Creditor', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/creditor-dashboard/creditor-dashboard.module').then(m => m.CreditorDashboardModule),
  },
  {
    path: 'client-parent/:clientParentId',
    data: {
      routeContext: DashboardRouteContext.create('ClientParent', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/client-parents-dashboard/client-parents-dashboard.module').then(m => m.ClientParentsDashboardModule),
  },
  {
    path: 'tenant/:tenantId',
    data: {
      routeContext: DashboardRouteContext.create('Tenant', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/tenants-dashboard/tenants-dashboard.module').then(m => m.TenantsDashboardModule),
  },
  {
    path: 'tenant-parent/:tenantParentId',
    data: {
      routeContext: DashboardRouteContext.create('TenantParent', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/tenant-parent-dashboard/tenant-parent-dashboard.module').then(m => m.TenantParentDashboardModule),
  },
  {
    path: 'landlord/:landlordId',
    data: {
      routeContext: DashboardRouteContext.create('Landlord', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/landlords-dashboard/landlords-dashboard.module').then(m => m.LandlordsDashboardModule),
  },
  {
    path: 'property/:propertyId',
    data: {
      routeContext: DashboardRouteContext.create('Property', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/properties-dashboard/properties-dashboard.module').then(m => m.PropertiesDashboardModule),
  },
  {
    path: 'property/:propertyId/unit/:unitId',
    data: {
      routeContext: DashboardRouteContext.create('Unit', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/units-dashboard/units-dashboard.module').then(m => m.UnitsDashboardModule),
  },
  {
    path: 'estate/:estateId',
    data: {
      routeContext: DashboardRouteContext.create('Estate', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/estates-dashboard/estates-dashboard.module').then(m => m.EstatesDashboardModule),
  },
  {
    path: 'client/:clientId',
    data: {
      routeContext: DashboardRouteContext.create('Client', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/clients-dashboard/clients-dashboard.module').then(m => m.ClientsDashboardModule),
  },
  {
    path: 'property/:propertyId/headlease/:headleaseId',
    data: {
      routeContext: DashboardRouteContext.create('Headlease', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/headleases-dashboard/headleases-dashboard.module').then(m => m.HeadleasesDashboardModule),
  },
  {
    path: 'property/:propertyId/vacant/:vacantId',
    data: {
      routeContext: DashboardRouteContext.create('Vacant', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/vacants-dashboard/vacants-dashboard.module').then(m => m.VacantsDashboardModule),
  },
  {
    path: 'lease/:leaseId',
    data: {
      routeContext: DashboardRouteContext.create('Lease', true)
    },
    canActivate: [OidcAuthRouteGuardService, EntityRouteGuard],
    loadChildren: () => import('@mojo-mci/leases-dashboard/leases-dashboard.module').then(m => m.LeasesDashboardModule),
  },

];
